import { render, staticRenderFns } from "./BcEmailDialog.vue?vue&type=template&id=4320cec7"
import script from "./BcEmailDialog.vue?vue&type=script&lang=js"
export * from "./BcEmailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports